import { render, staticRenderFns } from "./AnamnesisTab.vue?vue&type=template&id=d141f894"
import script from "./AnamnesisTab.vue?vue&type=script&lang=js"
export * from "./AnamnesisTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports